export const infos = (state) => {
  return state.infos;
};

export const infosCopy = (state) => {
  return state.infosCopy;
};

export const programs = (state) => {
  return state.programs;
};

export const products = (state) => {
  return state.products;
};

export const speakers = (state) => {
  return state.speakers;
};

export const loadingSpeakers = (state) => {
  return state.loadingSpeakers;
};

export const logos = (state) => {
  return state.logos;
};

export const loadingLogos = (state) => {
  return state.loadingLogos;
};

export const saveConfig = (state) => {
  return state.saveConfig;
};

export const campaings = (state) => {
  return state.campaings;
};

export const image = (state) => {
  return state.image;
};

export const hotsite = (state) => {
  return state.hotsite;
};

export const hotsiteVersions = (state) => {
  return state.hotsiteVersions;
};

export const hotsiteSelectedVersion = (state) => {
  return state.hotsiteSelectedVersion;
};

export const loading = (state) => {
  return state.loading;
};

export const snackbar = (state) => {
  return state.snackbar;
};

export const tickets = (state) => {
  return state.tickets;
};

export const sponsors = (state) => {
  return state.sponsors;
};

export const faq = (state) => {
  return state.faq;
};

export const productErrorMessage = (state) => {
  return state.productErrorMessage;
};

export const editViewType = (state) => {
  return state.editViewType;
};

export const crmList = (state) => {
  return state.crmList;
};

export const loadingCrm = (state) => {
  return state.loadingCrm;
};
